import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

// -------------------------------------------------------

const Tooltip = ({children}) => children || null;
const OverlayTrigger = ({children}) => children || null;

class DraftCheck extends React.Component {
  /*
   * 下書き作成
   */
  create() {
    let detail = this.props.detail;
    let insta_user_id = detail.influencer.insta_user_id;
    
    let chk = confirm('インフルエンサーの代わりに下書きを作成します。よろしいですか？\n（通常のフローとは異なる手順になりますご注意ください）');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/draft/create', { project_id: detail.project_id, insta_user_id: insta_user_id },
      function(res){
        location.href = '/draft/'+ res.body.new_draft_code;
        this.props.close_ev.bind(this)();
      }.bind(this),
      function(res){
        
        alert("B");
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // アクション
    if( Object.keys(detail.draft).length == 0 ){
      return (
        <div>
          <li className="on" onClick={this.create.bind(this)}>
            {this.props.button}
          </li>
        </div>
      );
    }
    
    // 使用できない
    return (
      <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>下書き作成済みの場合は、この操作ができません。</Tooltip>}>
        <li className="off">
          {this.props.button}
        </li>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftCheck;